let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lWdqq"), load("d5b66"), load("6XCf4"), load("5pvpJ"), load("1qlDN"), load("1yVM6"), load("6gpUD")]).then(() => parcelRequire('dTw2J'));